export enum TextColors {
  Blue = 'BLUE',
}
